<section class="wave">
	<svg
		width="100%"
		height="100%"
		viewBox="0 0 1000 1000"
		xmlns="http://www.w3.org/2000/svg"
		preserveAspectRatio="none"
		overflow="auto"
		shape-rendering="auto"
		fill="#ffffff">
		<defs>
			<path
				id="wavepath"
				d="M 0 2000 0 500 Q 200 200 400 500 t 400 0 400 0 400 0 400 0 400 0  v1000 z" />
			<path id="motionpath" d="M -800 0 0 0" />
		</defs>
		<g>
			<use xlink:href="#wavepath" y="50" fill="#ffffff">
				<animateMotion dur="6s" repeatCount="indefinite">
					<mpath xlink:href="#motionpath" />
				</animateMotion>
			</use>
		</g>
	</svg>
</section>
